module.exports = __webpack_public_path__ + "fonts/Satoshi-LightItalic.16186c3.woff2";